import { Fragment, useEffect, useState } from 'react';
import { Container, Row, Col, Table, Form, Modal, Button } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
// import lailaolab from './lailaolab.png';

// constants
import { COLOR_WHITE, S3_URL } from '../../const';
import { convertCurrency, convertDeliveryMethod, convertOrderStatus, numberFormat } from '../../helper';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import _ from 'lodash';
import { GET_ORDERGROUP } from '../../apollo/ordergroup/query';
import { useLazyQuery } from '@apollo/client';
import { GET_BANKS } from '../../apollo/bank/query';
import { GET_OFFERPRICEDATA } from '../../apollo/offerpricegroup/query';

const BillInvioce = ({ shopData, localOrder, orderStatus, componentType, providedData }) => {
    const { t } = useTranslation();
    const location = useLocation();
    const shop = JSON.parse(localStorage.getItem("SHOP_DATA"));
    
    // Use location state if props are not provided
    const orderData = localOrder || location?.state?.state || location?.state?.state || location?.state;
    const shopDataFinal = shopData || shop || location?.state?.shopData;

    const titleBillFinal = location?.state?.titleBill || "ໃບເກັບເງີນ(INVOICE)";
    const componentTypeFinal = componentType || location?.state?.componentType || "OFFERPRICE";
    
    // Initialize with actual order data, not the navigation wrapper
    const [orderGroupData, setOrderGroupData] = useState(providedData || orderData?.state || orderData);
    const [bankAccount, setBankAccount] = useState([])
    const [selectedBankIndex, setSelectedBankIndex] = useState(0)
    const [isSelectBankModalOpen, setIsSelectBankModalOpen] = useState(false)

    // Sync providedData to state if it updates from parent
    useEffect(() => {
        if (providedData) {
            setOrderGroupData(providedData);
        }
    }, [providedData]);

    const orderLists = orderGroupData?.offerprices || orderGroupData?.orders;
    const [orderGroup, { loading }] = useLazyQuery(GET_ORDERGROUP, { fetchPolicy: "cache-and-network" });
    const [offerPriceGroup, { loading: loadingOfferPrice }] = useLazyQuery(GET_OFFERPRICEDATA, { fetchPolicy: "cache-and-network" });
    const [getBank, { data: getbankData, loading: loadingBanks }] = useLazyQuery(GET_BANKS, { fetchPolicy: "cache-and-network", });
    console.log('orderGroupData',orderGroupData)
    useEffect(() => {
        if (getbankData) {
            setBankAccount(getbankData?.banks?.data);
        }
    }, [getbankData]);

    useEffect(() => {
        if (!bankAccount?.length) {
            setSelectedBankIndex(0)
            return
        }
        if (selectedBankIndex >= bankAccount.length) {
            setSelectedBankIndex(0)
        }
    }, [bankAccount, selectedBankIndex])

    useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    const fetchOrder = async () => {
        try {
            if (!orderGroupData?.id) {
                console.log("No ID found");
                return;
            }

            if (componentTypeFinal === "OFFERPRICE") {
                const result = await offerPriceGroup({
                    variables: {
                        where: {
                            id: orderGroupData.id, // ✅ your ID here
                        },
                    },
                    context: { fetchOptions: { signal } },
                });

                console.log("offerPriceGroup result: ", result);
                const apiData = result?.data?.offerpriceGroup;
                setOrderGroupData(apiData);

            } else {
                const result = await orderGroup({
                    variables: {
                        where: {
                            id: orderGroupData.id, // ✅ same here
                        },
                    },
                    context: { fetchOptions: { signal } },
                });

                console.log("orderGroup result: ", result);
                const apiData = result?.data?.orderGroup;
                setOrderGroupData(apiData);
            }

        } catch (error) {
            console.log("error fetchOrder: ", error);
        }
    };

    // ✅ Call function only if data is not provided
    if (!providedData) {
        fetchOrder();
    }

    return () => {
        controller.abort();
    };

}, [orderGroupData?.id, componentTypeFinal]);

    useEffect(() => {
        _fetchBank()
    }, [])
    // fetch bank datas
    const _fetchBank = async () => {
        let _localShop = JSON.parse(localStorage.getItem("SHOP_DATA"))
        if (!_localShop) return;
        try {
            await getBank({
                variables: {
                    limit: 100,
                    orderBy: "createdAt_DESC",
                    where: {
                        shop: _localShop?.id,
                        isDeleted: false,
                    },
                },
            });
        } catch (error) {
            console.log(error)
        }
    };

    const start = new Date(orderGroupData?.createdAt);
    const end = new Date(orderGroupData?.paymentDate);

    // Calculate the difference in milliseconds
    const diffInMilliseconds = end - start;

    // Convert milliseconds to days
    const diffInDays = diffInMilliseconds / (1000 * 60 * 60 * 24);

    const localShopId = (() => {
        try {
            return JSON.parse(localStorage.getItem("SHOP_DATA"))?.id
        } catch (e) {
            return undefined
        }
    })()
    const hideNoteColumnShopId = "698acf79cd9287001309d125"
    const activeShopId = shopDataFinal?.id || localShopId
    const shouldShowNoteColumn = activeShopId !== hideNoteColumnShopId
    const canSelectBankByQr = localShopId === "674532cf47f983007f44748d"
    const selectedBankAccount = canSelectBankByQr
        ? (bankAccount?.[selectedBankIndex] ?? bankAccount?.[0])
        : bankAccount?.[0]

    return (
        <Container className="mt-5 bill-offer-price-v2" style={{ maxWidth: 780, margin: "0 auto", padding: "16px 20px", fontSize: 12, lineHeight: 1.3 }}>
            <style>{`
                @media print {
                    .bill-offer-price-v2 {
                        margin: 0;
                        padding: 6mm 8mm;
                        max-width: 100%;
                        font-size: 11px;
                        line-height: 1.2;
                    }
                    .bill-offer-price-v2 h4 {
                        font-size: 16px;
                        margin: 4px 0;
                    }
                    .bill-offer-price-v2 h5 {
                        font-size: 13px;
                        margin: 4px 0;
                    }
                    .bill-offer-price-v2 p {
                        margin: 2px 0 !important;
                    }
                    .bill-offer-price-v2 table {
                        font-size: 10.5px;
                    }
                    .bill-offer-price-v2 th,
                    .bill-offer-price-v2 td {
                        padding: 4px 6px !important;
                    }
                    .bill-offer-price-v2 img {
                        max-height: 70px;
                    }
                    .bill-offer-price-v2 .form-check {
                        margin-bottom: 0;
                    }
                    .bill-offer-price-v2 .bank-account-list {
                        line-height: 1.2 !important;
                    }
                    .bill-offer-price-v2 .bank-account-list p {
                        margin: 2px 0 !important;
                    }
                }
            `}</style>
            <Row>
                <Col style={{ textAlign: 'right' }}>
                    <img src={S3_URL + shopDataFinal?.image} alt={shopDataFinal?.name} style={{ maxWidth: 80 }} />
                </Col>
                <Col style={{ minWidth: 350 }}>
                    <h5 className="text-center">{shopDataFinal?.name ?? "-"}</h5>
                    <p style={{ marginTop: -10 }} className="text-center">{shopDataFinal?.address?.village}, {shopDataFinal?.address?.district}, {shopDataFinal?.address?.province}</p>
                    <p style={{ marginTop: -10 }} className="text-center">ເບີໂທ: {shopDataFinal?.phone ?? "-"} ເລກລະຫັດວິສາຫະກິດ​: {shopDataFinal?.businessNumber ?? "...."}</p>
                    <h4 style={{ fontWeight: 'bold', textAlign: 'center' }}><b>{titleBillFinal ?? "ໃບເກັບເງິນ (Invoice)"}</b></h4>
                </Col>
                <Col></Col>
            </Row>

            <Row className="my-4">
                <Col>
                    <p style={{ marginTop: -10 }}><strong>{t("customer_name")}:</strong> {orderGroupData?.userConfirm?.name ?? "-"} {orderGroupData?.userConfirm?.lastname ?? "-"}</p>
                    <p style={{ marginTop: -10 }}><strong>{t("address")}:</strong> {orderGroupData?.userConfirm?.address?.village ?? "-"}, {orderGroupData?.userConfirm?.address?.district ?? "-"}, {orderGroupData?.userConfirm?.address?.province ?? "-"}</p>
                    <p style={{ marginTop: -10 }}><strong>{t("phone_number")}:</strong> {orderGroupData?.userConfirm?.phone ?? "-"}</p>
                    <p style={{ marginTop: -10 }}><strong>ພະນັກງານຂາຍ:</strong> {orderGroupData?.createdBy?.firstName ?? "-"} {orderGroupData?.createdBy?.lastName ?? "-"}</p>
                    <p style={{ marginTop: -10 }}><strong>ລະຫັດເຊວຂາຍ:</strong> {orderGroupData?.createdBy?.staffCode ?? "....."}</p>
                    <p style={{ marginTop: -10 }}><strong>ເບີໂທເຊວຂາຍ:</strong> {orderGroupData?.createdBy?.phone ?? "-"}</p>
                </Col>
                <Col>
                    <p style={{ marginTop: -10 }}><strong>ເລກໃບບິນ:</strong> {orderGroupData?.code ?? "-"}</p>
                    <p style={{ marginTop: -10 }}><strong>{t("day_month_year")}:</strong> {moment(orderGroupData?.createdAt).format('DD/MM/YYYY')}</p>
                    <p style={{ marginTop: -10 }}><strong>ໄລຍະເວລາ:</strong> {"..."}</p>
                    <p style={{ marginTop: -10 }}><strong>ກຳນົດວັນຊຳລະ:</strong> {moment(orderGroupData?.paymentDate).format('DD/MM/YYYY')}</p>
                    <div style={{ display: 'flex', gap: "3em" }}>
                        <Form.Check
                            type="checkbox"
                            id="custom-checkbox"
                            label="KIP"
                            checked={orderGroupData?.currency === "LAK" ? true : false}
                        />
                        <Form.Check
                            type="checkbox"
                            id="custom-checkbox"
                            checked={orderGroupData?.currency === "BAHT" ? true : false}
                            label="THB"
                        />
                        <Form.Check
                            type="checkbox"
                            id="custom-checkbox"
                            checked={orderGroupData?.currency === "USD" ? true : false}
                            label="USD"
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col >
                    <div style={{ display: 'flex', gap: 16 }}>

                        <Form.Check
                            type="checkbox"
                            id="custom-checkbox"
                            label="ເຄດິດ"
                            checked={(orderGroupData?.status === "NOTYETPAID" || orderGroupData?.status === "INDEBTED") ? true : false}
                            style={{ minWidth: 80 }}
                        />
                        <Form.Check
                            type="checkbox"
                            id="custom-checkbox"
                            label="ສົດ"
                            checked={orderGroupData?.payment === "CASH" ? true : false}
                            style={{ minWidth: 80 }}
                        />
                        <Form.Check
                            type="checkbox"
                            id="custom-checkbox"
                            label="ໂອນ"
                            checked={orderGroupData?.payment === "TRANSFER" ? true : false}
                            style={{ minWidth: 80 }}
                        />
                    </div>
                </Col>
            </Row>

            <Table responsive bordered >
                <thead style={{ background: COLOR_WHITE }}>
                    <tr>
                        <th style={{ color: "#000", textAlign: 'center' }} >ລຳດັບ <br /> (No)</th>
                        <th style={{ color: "#000", textAlign: 'center' }}>ຊື່ສິນຄ້າ<br />(Product)</th>
                        {/* <th style={{ color: "#000", textAlign: 'center' }}>ຫົວໜ່ວຍ<br />(Unit)</th> */}
                        {/* <th style={{ color: "#000", textAlign: 'center' }}>ຂະຫນາດ<br />(Size)</th> */}
                        <th style={{ color: "#000", textAlign: 'center' }}>ຈຳນວນ<br />(Qty)</th>
                        {/* <th style={{ color: "#000", textAlign: 'center' }}>ແຖມ<br />(Free)</th> */}
                        <th style={{ color: "#000", textAlign: 'center' }}>ລາຄາ<br />(Unit)</th>
                        <th style={{ color: "#000", textAlign: 'center' }}>ເປັນເງິນ<br />(Amount)</th>
                        {shouldShowNoteColumn ? <th style={{ color: "#000", textAlign: 'center' }}>ໝາຍເຫດ<br />(Note)</th> : null}
                    </tr>
                </thead>
                <tbody>
                    {orderLists?.map((item, index) => (
                        <Fragment key={item?.id ?? index}>
                            <tr>
                                <td>{index + 1}</td>
                                <td>{item?.productName ?? "-"}</td>
                                {/* <td>{item?.stock?.unitId?.name ?? "-"}</td> */}
                                {/* <td>
                                    {item?.stock?.size ?? '-'}
                                    {item?.stock?.dimension?.length ? '(' + item?.stock?.dimension?.length + 'x'
                                        + item?.stock?.dimension?.width + 'x' + item?.stock?.dimension?.height + 'x'
                                        + item?.stock?.dimension?.weight + ')' : ''}
                                </td> */}
                                <td align="center">{item?.amount} {item?.stock?.unit ?? item?.stock?.unitId?.name ?? ""}</td>
                                {/* <td align="center">{item?.amountFree ?? 0} {item?.stock?.unit ?? item?.stock?.unitId?.name ?? ""}</td> */}
                                <td>
                                    <div className="d-flex justify-content-between">
                                        <span>{convertCurrency(item?.currency ?? "LAK")}</span>
                                        <span>{numberFormat(item?.price)}</span>
                                    </div>
                                </td>
                                <td>
                                    <div className="d-flex justify-content-between">
                                        <span>{convertCurrency(item?.currency ?? "LAK")}</span>
                                        <span>{numberFormat(item?.amount * item?.price)}</span>
                                    </div>
                                </td>
                                {shouldShowNoteColumn ? <td>{item?.note ?? "-"}</td> : null}
                            </tr>
                            {(item?.children || []).map((child, cIdx) => (
                                <tr key={child?.id ?? `${index}-child-${cIdx}`} style={{ color: "green" }}>
                                    <td></td>
                                    <td>
                                        {"↳ "}{child?.productName ?? child?.stock?.name ?? "-"}
                                        {String(child?.tag || child?.saleTag || "").toUpperCase() === "FREE" ? " (ແຖມ)" : ""}
                                    </td>
                                    <td>
                                        {child?.stock?.size ?? '-'}
                                        {child?.stock?.dimension?.length ? '(' + child?.stock?.dimension?.length + 'x'
                                            + child?.stock?.dimension?.width + 'x' + child?.stock?.dimension?.height + 'x'
                                            + child?.stock?.dimension?.weight + ')' : ''}
                                    </td>
                                    <td align="center">{0} {child?.stock?.unit ?? child?.stock?.unitId?.name ?? ""}</td>
                                    <td align="center">{child?.amount ?? 0} {child?.stock?.unit ?? child?.stock?.unitId?.name ?? ""}</td>
                                    <td>
                                        <div className="d-flex justify-content-between">
                                            <span>{convertCurrency(child?.currency ?? item?.currency ?? "LAK")}</span>
                                            <span>{numberFormat(0)}</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="d-flex justify-content-between">
                                            <span>{convertCurrency(child?.currency ?? item?.currency ?? "LAK")}</span>
                                            <span>{numberFormat(0)}</span>
                                        </div>
                                    </td>
                                    <td></td>
                                </tr>
                            ))}
                        </Fragment>
                    ))}
                    <tr>
                        <td colSpan={shouldShowNoteColumn ? 4 : 3} >
                            <div>
                                <p className="font-medium"><b>ບັນຊີທະນາຄານ</b></p>
                                <p style={{ marginTop: -8 }}>ຊື່ບັນຊີ: {selectedBankAccount?.bankUser ?? "-"}</p>
                                <div className="d-flex gap-3">
                                    <div className="d-flex">
                                        <div className="pl-4 space-y-1 bank-account-list" style={{ lineHeight: 0.5 }}>
                                            {bankAccount?.map((bank, _index) => (
                                                <p
                                                    key={bank?.id}
                                                    style={{
                                                        fontWeight: canSelectBankByQr && _index === selectedBankIndex ? 700 : undefined,
                                                    }}
                                                >
                                                    <span></span> {" "} {bank?.bankAccount ?? "-"}
                                                </p>
                                            ))}
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            border: '1px solid #d2d2d2',
                                            width: 100,
                                            height: 110,
                                            cursor: canSelectBankByQr ? 'pointer' : undefined,
                                        }}
                                        onClick={() => {
                                            if (!canSelectBankByQr) return
                                            if (!bankAccount?.length) return
                                            setIsSelectBankModalOpen(true)
                                        }}
                                    >
                                        <img
                                            src={S3_URL + selectedBankAccount?.image}
                                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td rowSpan={3}>
                            <div className="p-4 d-flex justify-content-center align-items-center">
                                <h5 style={{ display: 'flex', width: '100%', justifyContent: 'space-between', fontSize: 18, paddingTop: 8 }}>ລວມເປັນກິບ</h5>
                                {/* <div />
                                <div />
                                <p style={{ marginTop: "3.85em" }}>ຄ່າຂົນສົ່ງ</p>
                                <p style={{ marginTop: -10 }}>ສ່ວນຫຼຸດ</p>
                                <p style={{ marginTop: -10 }}>ອາກອນ(Tax)</p>
                                <h5 style={{ fontWeight: 'bold', fontSize: 20, borderTop: '1px solid #dddd', paddingTop: 9 }}>ລວມທັງໝົດ</h5> */}
                            </div>
                        </td>
                        <td rowSpan={4}>
                            <div className="p-4 d-flex justify-content-center align-items-center">
                                {/* <p style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}><span>₭</span> {numberFormat(orderGroupData?.totalPrice ?? 0)}</p>
                                <p style={{ marginTop: -15, display: 'flex', width: '100%', justifyContent: 'space-between' }}><span>฿</span> {numberFormat(orderGroupData?.sumPriceBaht ?? 0)}</p>
                                <p style={{ marginTop: -15, display: 'flex', width: '100%', justifyContent: 'space-between' }}><span>$</span> {numberFormat(orderGroupData?.sumPriceUsd ?? 0)}</p>
                                <p style={{ marginTop: -5, display: 'flex', width: '100%', justifyContent: 'space-between' }}><span>₭</span> {numberFormat(orderGroupData?.shippingCost ?? 0)}</p>
                                <p style={{ marginTop: -5, display: 'flex', width: '100%', justifyContent: 'space-between' }}><span>₭</span> {orderGroupData?.discount ?? 0}%</p>
                                <p style={{ marginTop: -15, display: 'flex', width: '100%', justifyContent: 'space-between' }}><span>₭</span> 0</p> */}
                                {/* <h5 style={{ display: 'flex', width: '100%', justifyContent: 'space-between', fontWeight: 'bold', fontSize: 20, paddingTop: 8 }}><span>₭</span>  {numberFormat(orderGroupData?.sumPrice ?? 0)}</h5> */}
                                <h5 style={{ display: 'flex', width: '100%', justifyContent: 'space-between', fontSize: 18, paddingTop: 8 }}>
                                    <span>₭</span>
                                    <span>{numberFormat(orderGroupData?.sumPrice ?? 0)}</span>
                                </h5>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </Table>


            <p style={{ textAlign: 'center', width: '100%', fontWeight: 'bold', fontSize: 16 }}>ຂອບໃຈທີ່ທ່ານເຊື່ອໝັ້ນໃນບໍລິສັດຂອງພວກເຮົາ (Thank you for trusting our company!)</p>


            <Row className="mt-5 d-flex justify-content-start align-items-start">
                <Col className="d-flex justify-content-center flex-column align-items-center">
                    <p style={{ marginTop: -10, fontSize: 12 }}><strong>ລາຍເຊັນການເງິນ</strong></p>
                    <p style={{ marginTop: -10, fontSize: 12 }}><strong>Payee's signature</strong></p>
                </Col>
                <Col className="d-flex justify-content-center flex-column align-items-center">
                    <p style={{ marginTop: -10, fontSize: 12 }}><strong>ລາຍເຊັນຜູ້ຈັດສົ່ງ</strong></p>
                    <p style={{ marginTop: -10, fontSize: 12 }}><strong>Sender's signature</strong></p>
                </Col>
                <Col className="d-flex justify-content-center flex-column align-items-center">
                    <p style={{ marginTop: -10, fontSize: 12 }}><strong>ລາຍເຊັນລູກຄ້າ</strong></p>
                    <p style={{ textAlign: 'center', marginTop: -10, fontSize: 12 }}><strong>Customer Acceptance Signature</strong></p>
                </Col>
                <Col className="d-flex justify-content-center flex-column align-items-center">
                    <p style={{ marginTop: -10, fontSize: 12 }}><strong>ກາຈ້ຳ ແລະ ລາຍເຊັນບໍລິສັດ</strong></p>
                    <p style={{ textAlign: 'center', marginTop: -10, fontSize: 12 }}><strong>Company Stamp and Authorized Signature</strong></p>
                    {/* <img 
                        src={lailaolab} 
                        alt="Company Stamp" 
                        style={{ 
                            maxWidth: 120, 
                            maxHeight: 100, 
                            objectFit: 'contain',
                            margin: 0,
                            padding: 0,
                            marginTop: -15,
                        }} 
                    /> */}
                </Col>
            </Row>

            {canSelectBankByQr ? (
                <Modal
                    show={isSelectBankModalOpen}
                    onHide={() => setIsSelectBankModalOpen(false)}
                    centered
                    size="lg"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>ເລືອກບັນຊີທະນາຄານ</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="d-flex gap-3 flex-wrap">
                            {bankAccount?.map((bank, _index) => (
                                <div
                                    key={bank?.id ?? _index}
                                    style={{
                                        border: _index === selectedBankIndex ? '2px solid #2563eb' : '1px solid #d2d2d2',
                                        width: 180,
                                        padding: 10,
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => {
                                        setSelectedBankIndex(_index)
                                        setIsSelectBankModalOpen(false)
                                    }}
                                >
                                    <div style={{ border: '1px solid #d2d2d2', width: '100%', height: 160 }}>
                                        <img
                                            src={S3_URL + bank?.image}
                                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                        />
                                    </div>
                                    <div style={{ marginTop: 8, fontSize: 14, lineHeight: 1.2 }}>
                                        <div style={{ fontWeight: 700 }}>{bank?.bankName ?? "-"}</div>
                                        <div>{bank?.bankAccount ?? "-"}</div>
                                        <div>{bank?.bankUser ?? "-"}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setIsSelectBankModalOpen(false)}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            ) : null}
        </Container>
    );
};

export default BillInvioce;
